<template>
	<div class="box main-navbar" :class="NewYear ? 'main-navbarYear' : ''">
		<!-- v-if="$route.path.indexOf('menhu') == -1" -->
		<div class="menu-box">
			<div class="nav-name" :class="NewYear ? 'nav-nameYear' : ''" v-if="!isCollapse">— {{ system_name }} —</div>
			<div class="nav-name" :class="NewYear ? 'nav-nameYear' : ''" v-else>{{ system_name }}</div>
			<el-menu class="el-menu-vertical-demo" :class="{ 'isopen': isOpen, 'icon22': iconType != 4 }"
				@open="handleOpen" @close="handleClose" :collapse="isCollapse" :unique-opened="true"
				background-color="#1D78FE" text-color="#CEE2FF" active-text-color="#fff" :collapse-transition="false"
				:default-active="currentMenu" ref="navbar">
				<div>
					<fragment v-for="(item, index) in list" :key="index">
						<el-submenu v-if="item.page && item.has_child == 1" :index="system_name + '-' + index" class="111"
							popper-class="submenu-popper">
							<template slot="title">
								<local-svg :iconClass="item.icon + ''" class="icon"></local-svg>
								<span class="menu-name">{{ item.name }}</span>
							</template>
							<el-menu-item-group v-for="(tab, sonIndex) in item.page" :key="sonIndex">
								<el-menu-item :index="tab.route" @click="changPage(tab)" class="child-nav">{{
									tab.name
								}}
								</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-menu-item class="title-first" v-else :index="item.route" @click="changPage(item)"
							:class="{ 'is-active': item.route == currentMenu }">
							<local-svg v-if="NewYear" :iconClass="item.icon + '-NewYear'" class="icon"></local-svg>
							<!--              <local-svg v-if="NewYear" :iconClass="item.icon + ''" class="icon"></local-svg>-->
							<local-svg v-else :iconClass="item.icon + ''" class="icon"></local-svg>
							<span slot="title" class="menu-name">{{ item.name }}</span>
							<span class="menu-name" v-if="isCollapse">{{ item.name }}</span>
						</el-menu-item>
					</fragment>
				</div>
			</el-menu>
			<!-- && !isOpen -->
			<div class="navbar-version hover" v-show="!isCollapse" @click="seeVersionList">
				<div class="version">
					<div class="line"></div>
					<div class="main">
						<local-svg iconClass="version" class="icon"></local-svg>
						<span>{{ version_number }}</span>
					</div>
					<div class="line"></div>
				</div>
			</div>

			<div class="expand-btn" @click="getzs()"><span>{{ !isCollapse ? '收起' : '展开' }}</span></div>
		</div>


		<el-dialog title="" :visible.sync="versionDialog" width="960px" class="center-dialog dialog-element-change">
			<div class="dialog-main">
				<div class="header fl-between">
					<span class="title">版本记录</span>
					<span class="close" @click="closeVersionDialog"><local-svg iconClass="close"
							class="icon hover handel-header-icon"></local-svg></span>
				</div>
				<div class="main-box">
					<div class="select-line">
						<div class="select-left search-element-change-fw">
							<el-input class="select-input" type="text" v-model="selectName" placeholder="请输入关键字检索"
								style="width: 360px !important;">
								<el-select slot="prefix" placeholder="请选择" v-model="selectType">
									<el-option v-for="item in selectList" :label="item.name" :value="item.id"
										:key="item.id"></el-option>
								</el-select>
							</el-input>
							<span>更新时间</span>
							<el-date-picker v-model="form.updated_at" value-format="yyyy-MM-dd" range-separator="至"
								popper-class="dataoption-element-change" class="datetime-element-change"
								start-placeholder="开始日期" end-placeholder="结束日期" type="daterange" placeholder="请选择"
								:clearable="false" style="width: 256px !important;"></el-date-picker>
						</div>
						<div class="button-part">
							<button class="confirm hover" @click="seeVersionList('clear')">查询</button>
							<button class="cancel hover" style="margin-left: 12px;" @click="clearSearch">重置</button>
						</div>
					</div>
					<div class="table-part">
						<div class="table-header">
							<span class="title">版本列表</span>
							<div class="button-part">
								<button class="confirm-icon hover" @click="beginAddVersion">
									<local-svg iconClass="add" class="icon"></local-svg>
									添加
								</button>
							</div>
						</div>
						<div class="table-element-change-fw version-table">
							<el-table :data="tableData" height="462px" v-loading="loading" style="width: 100%;"
								ref="attractTable" tooltip-effect="light">
								<template slot="empty">
									<el-empty :image-size="250" :image="image" description='暂无数据'></el-empty>
								</template>
								<el-table-column width="30"></el-table-column>
								<el-table-column prop="version_number" label="版本号" width="80"></el-table-column>
								<el-table-column prop="update_time" label="更新时间" width="140">
									<template slot-scope="scope">
										<div>{{ scope.row.updated_at.split(' ')[0] }}</div>
									</template>
								</el-table-column>
								<el-table-column prop="update_content" label="更新内容">
									<template slot-scope="scope">
										<div style="white-space: pre-line;">{{ scope.row.update_content }}</div>
									</template>
								</el-table-column>
								<el-table-column label="操作" width="120">
									<template slot-scope="scope">
										<div class="handle-line">
											<span class="handel-text hover"
												@click="beginEditVersion(scope.row)">编辑</span>
											<span class="handel-text hover" style="margin-left: 10px;"
												@click="delVersion(scope.row)">删除</span>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="footer-line">
							<div class="page page-element-change ">
								<el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
									:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
									:page-sizes="[10, 20, 50, 100]" :total="total" :pager-count="5"
									popper-class="select-element-change">
								</el-pagination>
							</div>
							<div class="button-part">
								<button class="cancel hover" @click="closeVersionDialog">关闭</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="" :visible.sync="versionChangeDialog" width="640px"
			class="center-dialog dialog-element-change">
			<div class="dialog-main change">
				<div class="header fl-between">
					<span class="title">添加版本说明</span>
					<span class="close" @click="cancelChange"><local-svg iconClass="close"
							class="icon hover handel-header-icon"></local-svg></span>
				</div>
				<div class="main-box">
					<div class="form input-element-change textarea-element-change version-input">
						<div class="form-item">
							<div class="label"><span>*</span>版本号</div>
							<el-input v-model="addform.version_number" placeholder="请输入版本号"
								style="width: 461px;"></el-input>
						</div>
						<div class="form-item">
							<div class="label"><span>*</span>更新时间</div>
							<el-date-picker v-model="addform.updated_at" value-format="yyyy-MM-dd" style="width: 256px;"
								popper-class="dataoption-element-change" class="datetime-element-change" type="date"
								placeholder="请选择"></el-date-picker>
						</div>
						<div class="form-item">
							<div class="label"><span>*</span>版本更新内容</div>
							<el-input v-model="addform.update_content" placeholder="请输入更新内容" style="width: 461px;"
								type="textarea" resize="none"></el-input>
						</div>
					</div>
					<div class="button-part">
						<button class="cancel hover" @click="cancelChange">取消</button>
						<button class="confirm hover" style="margin-left: 10px;" @click="submitChange">保存</button>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { addvnumber, delvnumber, editvnumber, Vnumber } from '@/api/common'
import vm from '@/assets/js/closeNav'
import eventBus from '@/utils/eventBus';
import { mapState, mapMutations } from 'vuex';

export default {
	computed: {
		...mapState(['isCollapseVuex']), // 直接映射 Vuex 状态
		navtablist: function () {
			return this.$store.state.navtablist
		},
	},
	name: "NavBarLeft",
	props: {
		list: {
			type: Array,
			default: () => {
				return []
			}
		},
		iconType: {
			type: [Number, String]
		},
	},
	data() {
		return {
			isCollapse: false,
			currentMenu: '/custom',
			version: '',
			change_date: '',
			selectName: '',
			selectType: 1,
			selectList: [{ id: 1, name: '版本号' }, { id: 2, name: '更新内容' }],
			isOpen: false,
			versionDialog: false,
			versionChangeDialog: false,
			loading: false,
			image: require('../assets/image/none.png'),
			tableData: [],
			currentPage: 1,
			pageSize: 5,
			total: 100,
			system_name: '企业服务',
			version_number: '-',
			form: {
				updated_at: []
			},
			addform: {
				version_number: '',
				updated_at: '',
				update_content: '',
			},
			NewYear: this.$New_Year
		};
	},
	mounted() {
		this.getVersion()
		// this.$bus.$on('data', (data) => {
		//     if (data[2] === 1) {
		//         this.changPage(data[0])
		//         this.$router.push({
		//             path: '/custom',
		//             query: {
		//                 id: data[1].id,
		//                 num: 1
		//             }
		//         })
		//     }
		//     if (data[2] === 2) {
		//         this.changPage(data[0])
		//         // console.log(data[1].client_id);
		//         this.$router.push({
		//             path: '/custom',
		//             query: {
		//                 id: data[1].client_id,
		//                 num: 2
		//             }
		//         })
		//     } else {
		//         this.changPage(data[0])
		//         // console.log(data[1].client_id);
		//         this.$router.push({
		//             path: '/housecontract',
		//             query: {
		//                 id: data[1].h_c_id,
		//             }
		//         })
		//     }

		// })
		this.getType()
		this.getName()
		this.currentMenu = this.$route.path
	},
	watch: {
		$route(e) {
			this.currentMenu = e.path;
			this.$store.commit('setRoute', e.path)
			this.currentMenu = this.$route.path
		},
	},
	methods: {
		...mapMutations(['setCollapse']), // 直接映射修改方法
		changePage(e) {
			this.system_name = e
		},
		getVersion() {
			let data = {
				page: this.currentPage,
				limit: this.pageSize,
			}
			Vnumber(data).then(res => {
				if (res.data.total >= 0) {
					this.version_number = res.data.data[0].version_number
				}
			})
		},
		seeVersionList(e) {
			if (e) {
				this.currentPage = 1
			}
			let data = {
				page: this.currentPage,
				count: this.pageSize,
				version_number: this.selectType == 1 ? this.selectName : '',
				update_content: this.selectType == 2 ? this.selectName : '',
				updated_at: this.form.updated_at.toString(),
			}
			Vnumber(data).then(res => {
				this.tableData = res.data.data
				this.total = res.data.total
				this.versionDialog = true
			})
		},
		clearSearch() {
			this.form.updated_at = []
			this.selectName = ''
			this.selectType = 1
			this.seeVersionList('clear')
		},
		beginAddVersion() {
			this.addform = {
				version_number: '',
				updated_at: '',
				update_content: '',
			}
			this.versionChangeDialog = true
		},
		beginEditVersion(row) {
			this.addform = JSON.parse(JSON.stringify(row))
			this.versionChangeDialog = true
		},
		delVersion(row) {
			this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let data = {
					id: row.id
				}
				delvnumber(data).then(res => {
					if (res.code == 200) {
						this.$message.success('操作成功')
						this.seeVersionList()
						this.getVersion()
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			})
		},
		cancelChange() {
			this.versionChangeDialog = false
		},
		submitChange() {
			let data = {
				version_number: this.addform.version_number,
				updated_at: this.addform.updated_at,
				update_content: this.addform.update_content,
			}
			if (this.addform.id) {
				data.id = this.addform.id
				editvnumber(data).then(res => {
					if (res.code == 200) {
						this.$message.success('操作成功')
						this.versionChangeDialog = false
						this.seeVersionList()
						this.getVersion()
					} else {
						this.$message.error(res.msg)
					}
				})
			} else {
				addvnumber(data).then(res => {
					if (res.code == 200) {
						this.$message.success('添加成功')
						this.versionChangeDialog = false
						this.seeVersionList()
						this.getVersion()
					} else {
						this.$message.error(res.msg)
					}
				})
			}
		},
		closeVersionDialog() {
			this.versionDialog = false
		},
		handleOpen() {
			this.isOpen = true
		},
		handleClose() {
			this.isOpen = false
		},
		getzs() {
			this.isCollapse = !this.isCollapse
			// 发布事件，通知其他组件
			eventBus.$emit('collapseToggled', this.isCollapse);
			this.setCollapse(this.isCollapse); // 切换状态
		},
		getType() {
			vm.$on('closetype', value => {
				this.isCollapse = value
			})
		},
		getName() {
			vm.$on('nav', value => {
				this.system_name = value.name
				this.currentMenu = value.path
			})
		},
		changPage(data) {
			if (data.url) {
				if (data.system == 'scrm') {
					window.open(`${data.url}?p_token=${localStorage.getItem('token')}`, '_blank')
				} else {
					window.open(`${data.url}?token=${localStorage.getItem('token')}`, '_blank')
				}
				this.$nextTick(() => {
					this.$refs.navbar.handleItemClick(3)
				})
			} else {
				//如果menutab中存在该页面 使用缓存
				let obj = undefined;// this.navtablist.find(x => x.path == data.route)
				if (obj?.time) {
					// this.$router.push({
					// 	path: data.route,
					// 	query:{
					// 		q: obj.time, //没有q就没有缓存,即点击刷新
					// 	}
					// })
				} else {
					this.$router.push(data.route)
				}
				vm.$emit("closeobj", obj)
			}
		},
		handleCurrentChange(val) {
			this.currentPage = val
			this.seeVersionList()
		},
	}
}
</script>

<style lang="scss" scoped>
.main-navbar {
	.nav-name {
		width: 100%;
		text-align: center;
		font-size: 12px;
		color: #DEE6F8;
		line-height: 15px;
		height: 15px;
		padding: 20px 0;
		flex: none;
		box-sizing: content-box;
	}

	.nav-nameYear {
		color: white;
	}

	.menu-box {
		display: flex;
		flex-direction: column;
		height: 100%;
		position: relative;
		background: #1D78FE;

		.el-menu-vertical-demo {
			flex: 1;
			height: 100%;
			overflow: auto;
			padding-top: 0;
			scrollbar-width: none;
			max-height: calc(100vh - 280px) !important;
			&::-webkit-scrollbar {
				display: none;
			}

			.title-first.el-menu-item {
				.svg-icon {
					fill: #fff !important;
				}
			}
		}

		.navbar-version {
			height: 150px;
			width: 100%;
			position: absolute;
			left: 0;
			bottom: 0;
			background: linear-gradient(180deg, rgba(29, 120, 254, 0) 0%, #1D78FE 100%);
			border-radius: 0px 0px 0px 0px;
			display: flex;
			align-items: center;
			justify-content: center;

			.version {
				width: 100%;
				padding: 0 42px;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: space-between;
				line-height: 16px;

				.line {
					width: 24px;
					height: 1px;
					background: rgba(255, 255, 255, 0.3);
					color: #fff;
				}

				.main {
					display: flex;
					align-items: center;

					.icon {
						color: #ffffff60;
						margin-right: 8px;
						width: 16px;
						height: 14.5px;
					}

					span {
						color: #ffffff60;
						font-size: 14px;
					}
				}

				.main:hover {
					display: flex;
					align-items: center;

					.icon {
						color: #fff;
						margin-right: 8px;
						width: 16px;
						height: 14.5px;
					}

					span {
						color: #fff;
						font-size: 14px;
					}
				}
			}
		}

		.expand-btn {
			width: 20px;
			height: 60px;
			background: rgba(26, 107, 255, 0.15);
			font-weight: 400;
			font-size: 12px;
			color: #475B93;
			line-height: 14px;
			border-radius: 0px 6px 6px 0px;
			position: absolute;
			top: 0;
			right: -20px;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			cursor: pointer;
			z-index: 6;
		}

	}
}

.box.main-navbar {
	height: 100%;
	min-height: 100%;

	.el-menu-vertical-demo {
		box-sizing: border-box;
		height: auto;
		// min-height: 100%;
		// height: 100%;
		padding: 0px;
		border-right: none;

		&.isopen {
			padding-bottom: 20px !important;
		}
	}
}

.dialog-main {
	width: 960px;
	height: 720px;
	background: #FFFFFF;
	border-radius: 6px;

	.header {
		widows: 100%;
		height: 55px;
		border-bottom: 1px solid #F0F1F5;
		padding: 0 20px 0 30px;
		box-sizing: border-box;

		.title {
			font-weight: bold;
			font-size: 16px;
			color: #353940;
			line-height: 16px;
			margin-top: 10px;
		}
	}

	.main-box {
		width: 100%;
		height: 665px;
		padding: 20px 36px 29px;
		box-sizing: border-box;

		.select-line {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px dashed #EAEDF4;
			box-sizing: border-box;
			padding: 0 !important;
			padding-bottom: 20px !important;

			span {
				margin-left: 20px;
				margin-right: 12px;
				font-size: 14px;
				color: #4D535C;
				line-height: 16px;
			}

			.select-left {
				display: flex;
				align-items: center;
			}

			.button-part {
				flex: 1;
				margin-left: 20px;
			}
		}

		.table-part {
			padding-top: 16px;
			width: 100%;

			.table-header {
				display: flex;
				align-items: center;
				justify-content: space-between;

				span {
					font-weight: bold;
					font-size: 14px;
					color: #4D535C;
					line-height: 14px;
				}
			}

			.table-element-change-fw {
				margin-top: 8px;

				.handle-line {
					width: 100%;

					span {
						font-size: 14px;
						color: #37578F;
						line-height: 60px;
						margin-right: 20px;
					}

					span:last-child {
						margin-right: 0;
					}
				}
			}

			.footer-line {
				margin-top: 15px;
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
		}
	}
}

.dialog-main.change {
	width: 640px;
	height: 480px;
	background: #FFFFFF;
	border-radius: 6px;

	.header {
		widows: 100%;
		height: 55px;
		border-bottom: 1px solid #F0F1F5;
		padding: 0 20px 0 30px;
		box-sizing: border-box;

		.title {
			font-weight: bold;
			font-size: 16px;
			color: #353940;
			line-height: 16px;
			margin-top: 10px;
		}
	}

	.main-box {
		width: 100%;
		height: 425px;
		padding: 20px 36px 26px;
		box-sizing: border-box;

		.form {
			width: 100%;
			height: auto;

			.form-item {
				width: 100%;
				height: auto;
				display: flex;
				align-items: flex-start;
				margin-bottom: 16px;

				.label {
					font-size: 14px;
					color: #4D535C;
					line-height: 32px;
					width: 91px;
					text-align: right;
					margin-right: 16px;

					span {
						color: #F74B4B;
					}
				}
			}
		}

		.button-part {
			width: 100%;
			text-align: right;
		}
	}
}
</style>


<style lang="scss">
.main-box {
	.select-line {
		.select-left {
			.select-input.el-input--prefix {
				.el-input__inner {
					width: 360px !important;
				}

				.el-select {
					.el-input__inner {
						width: 120px !important;
					}
				}
			}
		}
	}
}

.box.main-navbar {
	.el-menu-vertical-demo.icon22 .icon {
		width: 22px;
		height: 22px;
	}

	.el-menu-vertical-demo {
		.logo {
			width: 100%;
			text-align: center;

			img {
				height: 80px;
				width: 80px;
				margin-bottom: 30px;
			}
		}

		.icon {
			width: 24px;
			height: 24px;
			margin-right: 14px;
		}

		.el-submenu__icon-arrow {
			right: 23px;
		}

		.is-opened {
			background-color: transparent !important;
		}

		.el-menu-item,
		.el-submenu__title {
			height: 48px !important;
			line-height: 48px !important;
			border-radius: 0px !important;
			padding: 0 24px 0 36px !important;
		}

		.el-menu .el-menu-item-group .el-menu-item.child-nav {
			height: 36px !important;
			line-height: 36px !important;
			padding: 0 24px 0 74px !important;

			&:hover {
				color: #fff !important;
				background: rgba(0, 0, 0, 0.1) !important;
				// font-weight: bold;
				// background: transparent!important;
			}
		}

		.el-submenu.is-active:hover {
			border-radius: 0px !important;
		}

		.el-submenu.is-active {
			background: transparent !important;

			.el-submenu__title {
				background-color: rgba(0, 0, 0, 0.2) !important;
				color: #fff !important;
			}

			.el-menu-item-group .el-menu-item.child-nav {
				border-radius: 0px !important;
				background-color: rgba(0, 0, 0, 0.1) !important;

				&:hover {
					color: #fff !important;
					font-weight: bold;
				}

				&.is-active {
					color: #fff !important;
					font-weight: bold;
				}
			}
		}

		.el-submenu__title:hover {
			background-color: rgba(0, 0, 0, 0.2) !important;
			border-radius: 0px !important;
			color: #CEE2FF !important;
		}

		.el-menu-item {
			&:hover {
				border-radius: 0px !important;
				background-color: rgba(0, 0, 0, 0.2) !important;
				color: #CEE2FF !important;
			}

			&.is-active {
				border-radius: 0px !important;
				background-color: rgba(0, 0, 0, 0.2) !important;
				color: #fff !important;
			}
		}


	}


	.el-menu-vertical-demo.el-menu--collapse.icon22 .el-menu-item .icon,
	.el-menu-vertical-demo.el-menu--collapse.icon22 .el-submenu__title .icon {
		width: 23px !important;
		height: 23px !important;
	}

	.el-menu-vertical-demo.el-menu--collapse {
		width: 80px !important;

		.el-menu-item .el-tooltip {
			flex-direction: column;
		}

		.el-menu-item,
		.el-submenu__title {
			height: 80px !important;
			border-radius: 0px !important;
			padding: 0 !important;
			justify-content: center;
			flex-direction: column;

			.icon {
				width: 23px !important;
				height: 23px !important;
				margin: 0 !important;
				flex: none;
			}

			.menu-name {
				margin-top: 6px;
				font-weight: 400;
				font-size: 12px;
				color: #FFFFFF;
				line-height: 18px;
				overflow: hidden;
				width: 100%;
				text-align: center;
				white-space: nowrap;
				text-overflow: ellipsis;
			}
		}

		.el-submenu.is-active .el-submenu__title,
		.el-menu-item.is-active {
			.menu-name {
				font-weight: bold;
			}
		}

		.title-first.el-menu-item .el-tooltip {
			padding: 0 !important;
			display: flex !important;
			justify-content: center;
			align-items: center;
		}

		.el-submenu__icon-arrow {
			display: none;
		}
	}

}


.el-menu--vertical.submenu-popper .el-menu--popup {
	padding: 7px 0 !important;
	border-radius: 5px 5px 5px 5px;

	.el-menu-item {
		height: 36px !important;
		line-height: 36px !important;
		color: #9CA3B6 !important;
		padding: 0 20px !important;
		text-align: center;
		border-radius: 0;

		&:hover {
			color: #1D78FE !important;
			background: #fff !important;
		}

		&.is-active {
			color: #1D78FE !important;
			background: #F4F6FE !important;
		}
	}
}

.el-tooltip__popper.is-dark {
	.popper__arrow {
		border-right-color: #ccc !important;
	}

	.popper__arrow::after {
		display: block !important;
		border-right-color: #FFFFFF !important;
		border-bottom-color: transparent !important;
	}
}


.main-navbar .version-dialog {
	.el-dialog__header {
		display: none !important;
	}

	.el-dialog__body {
		padding: 0 !important;
	}

	.dialog-main {
		width: 100%;
		// height: 680px;

		.header {
			width: 100%;
			height: 56px;
			padding: 25px 30px 14px;
			border-bottom: 1px solid #F0F1F5;
			box-sizing: border-box;

			.title {
				font-weight: bold;
				font-size: 16px;
				color: #353940;
				line-height: 16px;
			}

			.close {
				.icon {
					position: absolute;
					top: 20px;
					right: 20px;
					width: 14px;
					height: 14px;
					color: #B4C1D6;
					cursor: pointer;
				}

				&:hover .icon {
					color: #1D78FE !important;
				}
			}
		}

		.table {
			width: 100%;
			height: 500px;
			padding: 0 36px;
			box-sizing: border-box;
			margin-top: 20px;

			.file-name {
				width: 190px;
			}

			.el-table__body-wrapper .el-table__cell,
			.el-table__fixed-body-wrapper .el-table__cell {
				height: 50px;
				padding: 0;
			}
		}

		.el-table__empty-block {
			padding-bottom: 0 !important;
		}

		.page {
			width: 100%;
			text-align: right;
			box-sizing: border-box;
			padding: 0 36px 26px;
			margin-top: 27px;
		}
	}
}
</style>
<style lang="scss">
.main-navbarYear {

	.menu-box {
		background: #A03F2B !important;

		.el-menu-vertical-demo {
			background: #A03F2B !important;

			.el-menu-item {
				background: #A03F2B !important;
				color: white !important;
			}

			.el-submenu {
				.el-submenu__title {
					background: #A03F2B !important;
					color: white !important;
				}

				.el-menu {
					background: #A03F2B !important;
				}
			}
		}

		.navbar-version {
			background: #A03F2B !important;


			.version {
				.line {
					background: rgba(255, 255, 255, 0.3);
					color: #fff;
				}

				.main {


					.icon {
						color: #ffffff60;
					}

					span {
						color: #ffffff60;

					}
				}

				.main:hover {

					.icon {
						color: #fff;
					}

					span {
						color: #fff;
					}
				}
			}
		}
	}
}

.box.main-navbarYear .el-menu-vertical-demo .el-menu-item:hover {
	color: white !important;
}
</style>
